import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { normalizeExpectedStartTime } from "./ReservationPromptDialog/expectedStartTime";

export default function ExpectedStartTime({ value, sx }) {
    const { t } = useTranslation();
    const time = normalizeExpectedStartTime(value);
    if (!time) return null;
    return (
        <Typography variant="body2" sx={sx}>
            {t("pos.reservationPrompt.expectedStartTime")}: <bdi dir="ltr">{time}</bdi>
        </Typography>
    );
}
